import { Link } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';

export function FinalCTA() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <section className="landing-final-cta">
        <div className="landing-section-inner">
          <h2>{isAuthenticated ? 'Ready to continue planning?' : 'You don\'t need all the answers yet. You just need to see the picture.'}</h2>
          {isAuthenticated ? (
            <Link to="/plan" className="landing-btn landing-btn-primary">Go to My Plan</Link>
          ) : import.meta.env.DEV ? (
            <Link to="/register" className="landing-btn landing-btn-primary">Register</Link>
          ) : (
            <>
              <p className="landing-final-cta-subtext">We're opening access to new users each week. Enter your email and we'll send you an invitation.</p>
              <div className="landing-final-cta-actions">
                <a href="#beta-request" className="landing-btn landing-btn-primary">Request Early Access</a>
              </div>
            </>
          )}
        </div>
      </section>

      <footer className="landing-footer">
        <div className="landing-section-inner">
          <p className="landing-footer-disclaimer">
            Glide-Path is an educational tool, not financial advice. Projections are illustrative
            and based on assumptions that may not reflect actual outcomes. The value of pensions
            and investments can go down as well as up. You may get back less than you invest.
            Future tax bands and allowances are projected using assumed inflation and may differ
            from actual HMRC policy. National Insurance contributions and entitlements are not
            modelled. Consult the government's Check your State Pension forecast service (gov.uk)
            for your personal State Pension entitlement. This tool does not take into account your
            personal circumstances. For personalised financial planning, you may wish to seek
            independent advice.
          </p>
          <p className="landing-footer-links">
            <Link to="/terms">Terms of Service</Link>
            {' · '}
            <Link to="/privacy">Privacy Policy</Link>
          </p>
          <p className="landing-footer-copy">
            &copy; {new Date().getFullYear()} Longview Technology Ltd. All rights reserved.
          </p>
          <p className="landing-footer-entity">
            Glide-Path is operated by Longview Technology Ltd, a company registered in
            England and Wales, company number 15617305.
          </p>
        </div>
      </footer>
    </>
  );
}
